// extracted by mini-css-extract-plugin
export var grid = "my-nfts-module--grid--Kzk28";
export var nft = "my-nfts-module--nft--VZw8Y";